import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AllActionsUnion } from 'src/app/app.actions';
import {
  reauthSuccess,
  resetState,
  showReauthModal,
  storeErrorMessage,
  updateLoading,
} from './reauth.actions';

export interface ReauthState {
  showModal: boolean;
  loading: boolean;
  errorMessage: string;
  reauthSuccess: boolean;
}

const initialState: ReauthState = {
  showModal: false,
  loading: false,
  errorMessage: '',
  reauthSuccess: false,
};

export const featureName = 'reauthFeature';

export function reauthReducer(
  state_: ReauthState | undefined,
  action: AllActionsUnion,
): ReauthState {
  const reducer_ = createReducer<ReauthState>(
    initialState,
    on(
      storeErrorMessage,
      (state, { payload }): ReauthState => {
        return { ...state, errorMessage: payload };
      },
    ),
    on(
      reauthSuccess,
      (state): ReauthState => {
        return { ...state, reauthSuccess: true };
      },
    ),
    on(
      updateLoading,
      (state, { payload }): ReauthState => {
        return { ...state, loading: payload };
      },
    ),
    on(
      showReauthModal,
      (state, { payload }): ReauthState => {
        return { ...state, showModal: payload };
      },
    ),
    on(
      resetState,
      (): ReauthState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<ReauthState>(featureName);

export const getErrorMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.errorMessage,
    ),
  ),
  distinctUntilChanged(),
);

export const getReauthSuccess = pipe(
  select(
    createSelector(
      getFeature,
      v => v.reauthSuccess,
    ),
  ),
  distinctUntilChanged(),
);

export const getLoading = pipe(
  select(
    createSelector(
      getFeature,
      v => v.loading,
    ),
  ),
  distinctUntilChanged(),
);

export const getShowReauthModal = pipe(
  select(
    createSelector(
      getFeature,
      v => v.showModal,
    ),
  ),
  distinctUntilChanged(),
);
